import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class DementiaSeriesService {
  private readonly dementiaSeriesBaseApiUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.dementiaSeriesBaseApiUrl = `${baseUrl}api/dementia-series`;
  }

  public getDementiaSeries() {
    let dementiaSeriesApiUrl = `${this.dementiaSeriesBaseApiUrl}/`;

    return this.dataService.get<any>(dementiaSeriesApiUrl);
  }

  public downloadFile(fileName) {
    let fileApiUrl = `${this.dementiaSeriesBaseApiUrl}/files/${btoa(fileName)}`;

    return this.dataService.getFile(fileApiUrl);
  }
}
